import React, { useEffect } from "react";
import { connect } from "react-redux";
import DownloadButton from "@buttons/DownloadButton";
import { Button, Icon } from "semantic-ui-react";
import useComplianceView from "@hooks/useComplianceView";
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import useProcessPeriodModal from "@hooks/useProcessPeriodModel";
import { confirmModal } from "@actions/modals";
import { useSelector } from "react-redux";

const EventDetailsButtons = () => {
  const { companyId, onLoadProcess, disableProcessQuarterBtn, onProcessClick } =
    useProcessPeriodModal();
  const {
    operator,
    hasSelection,
    quarter: { quarterName, year },
    isLoading,
  } = useComplianceView();
  const { onRefresh } = useEventDetailsGrid();
  const { optionComplianceAllowPeriodEnd } = useSelector(
    (state) => state.logIn,
  );

  useEffect(onLoadProcess, [companyId, operator, hasSelection]);

  const disabled = isLoading || !hasSelection;

  return (
    <>
      <Button
        positive
        icon="refresh"
        content="Refresh"
        onClick={() => onRefresh(false, false, null, true)}
        disabled={disabled}
      />

      <Button
        disabled={disabled || !year || !optionComplianceAllowPeriodEnd}
        onClick={() => onProcessClick()}
        color={disableProcessQuarterBtn ? "grey" : "black"}
      >
        <Icon name="list" />
        Process {quarterName}
      </Button>

      <DownloadButton
        caption="Export"
        disabled={disabled}
        onClick={() => onRefresh(true)}
        size="medium"
      />
    </>
  );
};

export default connect(null, { confirmModal })(EventDetailsButtons);
